// Case Attribute
export enum EKwikUIInputEmailCase {
  DEFAULT = "default",
  UPPER = "upper",
  LOWER = "lower"
}
export const VKwikUIInputEmailCase = [
  EKwikUIInputEmailCase.DEFAULT,
  EKwikUIInputEmailCase.UPPER,
  EKwikUIInputEmailCase.LOWER
] as const;

export type TKwikUIInputEmailCase = (typeof VKwikUIInputEmailCase)[number];

// Size Attribute
export enum EKwikUIInputEmailSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputEmailSize = [
  EKwikUIInputEmailSize.S,
  EKwikUIInputEmailSize.M,
  EKwikUIInputEmailSize.L
] as const;

export type TKwikUIInputEmailSize = (typeof VKwikUIInputEmailSize)[number];
